import React from "react";
import { Navbar, Nav } from "react-bootstrap";
import { _t } from "../i18n/i18n";
import { useSelector } from "react-redux";
import { UI_LANG, DOMICILE } from "../../redux/slices/api/initialisePreferences";
import { JPRiskAndFees } from "./parts/JPRiskAndFees";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import { useIsPublicPage } from "lib/routing";

export const Footer = () => {
  const location = useLocation();
  const isPublic = useIsPublicPage();
  const domicile = useSelector((state) => state.preferences[DOMICILE])[0];
  const lang = useSelector((state) => state.preferences[UI_LANG])[0];
  const urls = getDisclaimerUrls(isPublic);

  if (shouldHideFooter(location)) return null;

  return (
    <Navbar bg="dark" variant="dark text-white pt-3 border-top" expand="sg" style={{ zIndex: 2 }}>
      {domicile === "ja" ? (
        <JapanDomicileFooter lang={lang} urls={urls} isPublic={isPublic} />
      ) : (
        <IntlDomicileFooter lang={lang} urls={urls} isPublic={isPublic} />
      )}
    </Navbar>
  );
};

export const JapanDomicileFooter = ({ lang, urls, isPublic }) => {
  return (
    <>
      <JPRiskAndFees />
      <br className="d-md-none" />
      {!isPublic && (
        <Link className="nav-link" to={urls.japan.disclaimers[lang]}>
          {_t("Disclaimers")}
        </Link>
      )}
      {!isPublic && (
        <Link className="nav-link" to={urls.japan.disclosures}>
          {_t("Disclosures")}
        </Link>
      )}
      <Link className="nav-link" to={urls.japan.nscTermsOfUse[lang]}>
        {_t("Agreement")}
      </Link>
      <Nav.Link href={urls.japan.privacyPolicy[lang]}>{_t("Privacy Policy")}</Nav.Link>
      <Link className="nav-link" to={urls.japan.nscRiskAndCommission[lang]}>
        {_t("Risk and Commission")}
      </Link>
      <br className="d-md-none" />
      <Nav.Link>
        <br className="d-md-none" />
        COPYRIGHT © 2001-{currentYear} Nomura Securities Co., Ltd. &nbsp;
        <br className="d-md-none" />
        &nbsp; All Rights Reserved.
      </Nav.Link>
    </>
  );
};

export const IntlDomicileFooter = ({ lang, urls, isPublic }) => {
  return (
    <>
      {!isPublic && (
        <Link className="nav-link" to={urls.intl.disclaimers[lang]}>
          {_t("Disclaimers")}
        </Link>
      )}
      {!isPublic && (
        <Link className="nav-link" to={urls.intl.disclosures}>
          {_t("Disclosures")}
        </Link>
      )}
      <Link className="nav-link" to={urls.intl.nhiDisclaimers}>
        {_t("Disclaimers (International)")}
      </Link>
      <Link className="nav-link" to={urls.intl.nhiTermsOfUse}>
        {_t("Agreement")}
      </Link>
      <Nav.Link href={urls.intl.privacyPolicy[lang]}>{_t("Privacy Policy")}</Nav.Link>
      <Nav.Link href={urls.intl.acPolicy[lang]}>{_t("Accessibility Policy")}</Nav.Link>
      <br className="d-md-none" />
      <div className="w-100">
        <br className="d-md-none" />© 2001-{currentYear} Nomura Holdings Inc. &nbsp;
        <br className="d-md-none" />
        All Rights Reserved.
      </div>
    </>
  );
};

// urls depend on domicile (international vs japan domicile), then language preference:
const getDisclaimerUrls = (isPublic = false) => {
  const prefix = isPublic ? "/public" : "";
  return {
    intl: {
      disclaimers: {
        en: "/Disclaimers/en",
        ja: "/Disclaimers/ja",
      },
      disclosures: "/Disclosures",
      nhiDisclaimers: prefix + "/Disclaimers/nhi-disclaimer",
      nhiTermsOfUse: prefix + "/Disclaimers/nhi-terms-of-use-en", //note no translation available
      privacyPolicy: {
        en: "https://www.nomuraholdings.com/policy/privacy.html",
        ja: "https://www.nomuraholdings.com/jp/policy/privacy.html",
      },
      acPolicy: {
        en: "https://www.nomuraholdings.com/policy/acpolicy.html",
        ja: "https://www.nomuraholdings.com/jp/policy/acpolicy.html",
      },
    },

    japan: {
      disclaimers: {
        en: "/Disclaimers/en",
        ja: "/Disclaimers/ja",
      },
      disclosures: "/Disclosures",
      nscTermsOfUse: {
        en: prefix + "/Disclaimers/nsc-terms-of-use-en",
        ja: prefix + "/Disclaimers/nsc-terms-of-use-ja",
      },
      privacyPolicy: {
        en: "http://www.nomuraholdings.com/policy/privacy.html",
        ja: "https://www.nomura.co.jp/privacy.html",
      },
      nscRiskAndCommission: {
        en: prefix + "/Disclaimers/nsc-risk-and-commission-en",
        ja: prefix + "/Disclaimers/nsc-risk-and-commission-ja",
      },
    },
  };
};

const shouldHideFooter = ({ pathname, search }) =>
  pathname.includes("/videoplayer") || pathname.includes("/public/Analyst_Directory") || search.includes("hideFooter");
const currentYear = new Date().getFullYear();
